module.exports = __webpack_public_path__ + "img/blue_089.3de54b31.png";